import { Injectable } from '@angular/core';
import { Reimbursement } from '@bciti/types';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export abstract class ReimbursementsService {
    abstract postReimbursement(body: Reimbursement): Observable<boolean>;
}
